<div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" class="mt-1">
  <div fxLayout="row" fxLayoutGap="10px">
    <span>{{ labelKey | translate | mmxTitlecase}}</span>
  </div>
</div>
